<template>
  <div
    ref="kt_faturamento_modal_desconto"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_faturamento_modal_desconto"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-md mw-400px modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/finance/fin010.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Desconto</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="$emit('exibirModalDesconto', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-4">
          <div class="card border border-rounded border-gray-300 mb-4 p-6">
            <div class="row">
              <div class="col-6 fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbDesconto"
                    id="rbDescontoReal"
                    @change="atualizarValorFinal()"
                    checked
                  />
                  <label
                    class="form-check-label fs-6 fw-bold"
                    for="rbDescontoReal"
                  >
                    Desconto em R$
                  </label>
                </div>
              </div>
              <div class="col-6 fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbDesconto"
                    id="rbDescontoPorcentagem"
                    @change="atualizarValorFinal()"
                  />
                  <label
                    class="form-check-label fs-6 fw-bold"
                    for="rbDescontoPorcentagem"
                  >
                    Desconto em %
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 fv-row d-flex justify-content-start">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbDesconto"
                    id="rbAcrescimoReal"
                    @change="atualizarValorFinal()"
                  />
                  <label
                    class="form-check-label fs-6 fw-bold"
                    for="rbAcrescimoReal"
                  >
                    Acréscimo em R$
                  </label>
                </div>
              </div>
              <div class="col-6 fv-row d-flex justify-content-start">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbDesconto"
                    id="rbAcrescimoPorcentagem"
                    @change="atualizarValorFinal()"
                  />
                  <label
                    class="form-check-label fs-6 fw-bold"
                    for="rbAcrescimoPorcentagem"
                  >
                    Acréscimo em %
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card border border-rounded border-gray-300 pt-4">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="fv-row flex-column d-flex align-items-center">
                  <label class="form-label">{{ this.labelTotal }}</label>
                  <div
                    class="form-control form-control-transparent mb-2 mw-200px fs-1 text-center py-0 text-primary"
                  >
                    R$ {{ this.$utils.formatarNumero(this.total) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-4">
                <div
                  class="fv-row flex-column d-flex align-items-center text-center"
                >
                  <label class="form-label">{{ this.labelDesconto }}</label>
                  <CurrencyInput
                    id="txtValorDesconto"
                    class="form-control fs-1 mw-200px"
                    style="text-align: center"
                    v-model="this.valorDesconto"
                    :options="options"
                    @input="atualizarValorFinal()"
                    @keydown.stop.prevent.enter="this.confirmarDesconto()"
                  ></CurrencyInput>
                  <div class="fv-plugins-message-container invalid-feedback">
                    {{ errosValidacao["valor_desconto"] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-4">
                <div class="fv-row flex-column d-flex align-items-center">
                  <label class="form-label">Valor Final</label>
                  <div
                    class="form-control form-control-transparent mb-2 mw-200px fs-1 text-center text-danger py-0"
                  >
                    R$ {{ this.$utils.formatarNumero(this.valorFinal) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="this.exibirRemoverDesconto === true" class="row">
            <div class="col-12 pt-4">
              <button
                class="d-flex justify-content-center align-items-center btn-bg-light btn btn-active-light-danger svg-icon-white w-100"
                @click="removerDesconto()"
              >
                <i class="la la-trash-o p-0 fs-1 me-1"></i>
                Remover Desconto/Acréscimo concedido
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="$emit('exibirModalDesconto', false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmarDesconto()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["exibirModalDesconto", "confirmarDesconto", "removerDesconto"],
  components: { CurrencyInput },
  props: {
    total: { type: Number, required: true },
    labelTotal: { type: String, required: true, default: "" },
    exibirRemoverDesconto: { type: Boolean, required: true, default: true },
  },
  methods: {
    atualizarValorFinal() {
      //Metódo para não permitir valor de desconto negativo
      this.valorDesconto = Math.abs(this.valorDesconto);

      var radio = document.getElementsByName("rbDesconto");
      //Desconto em R$
      if (radio[0].checked) {
        this.labelDesconto = "Desconto R$";
        this.valorFinal = this.total - this.valorDesconto;
      }
      //Desconto em %
      if (radio[1].checked) {
        this.labelDesconto = "Desconto %";
        this.valorFinal = this.total - (this.total * this.valorDesconto) / 100;
      }
      //Acréscimo em R$
      if (radio[2].checked) {
        this.labelDesconto = "Acréscimo R$";
        this.valorFinal = this.total + this.valorDesconto;
      }
      //Acréscimo em %
      if (radio[3].checked) {
        this.labelDesconto = "Acréscimo %";
        this.valorFinal = this.total + (this.total * this.valorDesconto) / 100;
      }
    },
    confirmarDesconto() {
      this.errosValidacao = [];
      var error = "";
      if (this.valorDesconto === 0 || this.valorDesconto === null) {
        error =
          "O valor do " +
          this.labelDesconto
            .replace("R$", "")
            .replace("%", "")
            .toLocaleLowerCase()
            .trim() +
          " não pode estar zerado!";
      } else if (this.valorFinal <= 0) {
        error = "O valor final não deve ser menor ou igual à zero!";
      }

      if (error != "") {
        this.errosValidacao = {
          valor_desconto: error,
        };
        toast.error(error, {
          timeout: 3000,
        });
      } else {
        var descontoCalculado = this.valorFinal - this.total;
        this.$emit("confirmarDesconto", descontoCalculado, this.labelTotal);
        hideModal(this.$refs.kt_faturamento_modal_desconto);
        this.$emit("exibirModalDesconto", false);
      }
    },
    async removerDesconto() {
      await this.$swal.showQuestionAlert(
        "Deseja remover o desconto / acréscimo concedido?",
        (alert) => {
          if (alert.isConfirmed) {
            this.$emit("removerDesconto", this.labelTotal);
            hideModal(this.$refs.kt_faturamento_modal_desconto);
            this.$emit("exibirModalDesconto", false);
          }
        }
      );
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    this.valorDesconto = 0;
    this.valorFinal = 0;
    this.errosValidacao = [];
    this.labelDesconto = "";
    this.$utils.requestFocus("txtValorDesconto");

    this.atualizarValorFinal();
  },
  data() {
    return {
      valorDesconto: 0,
      valorFinal: 0,
      errosValidacao: [],
      labelDesconto: "",
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
